module.exports = __webpack_public_path__ + "img/c03_buildingtechriteofrudiobus_Normal_ua.e9f29adf.webp";